<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:">
        <el-input v-model="searchForm.reProjectName" placeholder="请输入项目名称" clearable />
      </el-form-item>
      <el-form-item label="退换货合同编号:">
        <el-input v-model="searchForm.reNewContractNum" placeholder="请输入退换货合同编号" clearable @blur="searchForm.reNewContractNum = (searchForm.reNewContractNum || '').trim()" />
      </el-form-item>
      <el-form-item label="原合同编号:">
        <el-input v-model="searchForm.reOldContractNum" placeholder="请输入原合同编号" clearable @blur="searchForm.reOldContractNum = (searchForm.reOldContractNum || '').trim()" />
      </el-form-item>
      <el-form-item label="部门:">
        <el-input v-model="searchForm.reSalesPersonDeptName" placeholder="请输入部门" clearable />
      </el-form-item>
      <el-form-item label="区域:">
        <el-input v-model="searchForm.areaGroup[0]" placeholder="请输入区域" clearable />
      </el-form-item>
      <el-form-item label="合同时间:">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div class="date-separator">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="外销:">
        <el-input v-model="searchForm.reSalesPersonName" placeholder="请输入外销" clearable />
      </el-form-item>

      <el-form-item label="客户名称:">
        <el-input v-model="searchForm.orderUnitName" placeholder="请输入客户名称" clearable />
      </el-form-item>

      <el-form-item label="退换货类型：" prop="reReasonType">
        <el-select v-model="searchForm.reReasonType" placeholder="请选择">
          <el-option v-for="(item, index) in returnList" :key="index" :label="displayReasonType(item)" :value="item" />
        </el-select>
      </el-form-item>

      <el-form-item label="已分配比例：" class="undistributed-money">
        <el-input v-model.number="searchForm.startRatio" placeholder="填写比例" />
        <span> - </span>
        <el-input v-model.number="searchForm.endRatio" placeholder="填写比例" />
      </el-form-item>

      <el-form-item label="流程状态：" prop="processStatus">
        <el-select v-model="searchForm.processStatus" placeholder="请选择">
          <el-option v-for="(item, index) in statusList" :key="index" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" :loading="Loading" @click="searchData">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="项目名称" align="left" min-width="200" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" class="el-btn-text-left" @click="jumpProjectDetail(row)">
              {{ row.reProjectName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="reNewContractNum" label="退换货合同编号" align="left" width="150" fixed="left" />
        <el-table-column prop="reOldContractNum" label="原合同编号" align="left" width="150" />
        <el-table-column prop="reOrderUnitName" label="客户名称" align="left" width="150" />
        <el-table-column prop="reContractType" label="合同类型" align="left" width="120" />
        <el-table-column prop="reReasonType" label="退换货类型" align="left" width="150">
          <template v-slot="{row}">
            {{ displayReasonType(row.reReasonType) }}
          </template>
        </el-table-column>
        <el-table-column prop="reSalesPersonName" label="外销" align="left" width="120" />
        <el-table-column prop="reSalesPersonDeptName" label="部门" align="left" width="120" />
        <el-table-column prop="reSalesArea" label="区域" align="left" width="120" />
        <el-table-column prop="createdTime" label="合同时间" align="left" width="140" />
        <el-table-column label="已分配金额/比例" align="right" width="120" header-align="left">
          <template v-slot="{row}">
            {{ row.reDeductionAmount }}/{{ row.assignedRatio }}
          </template>
        </el-table-column>
        <el-table-column prop="convertContractStatus" label="流程状态" align="left" width="120" />
        <el-table-column label="操作" align="left" width="210" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="showeContractEnclosure(row)">
              合同附件
            </el-button>
            <el-button v-if="row.reContractType === '换货合同' && row.reContractStatus === 4" type="text" @click="showApplyChange(row)">
              申请退换货
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          :page-sizes="[10]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>

    <!-- 合同附件 -->
    <enclosure-dialog ref="enclosure" />

    <!-- 分配查看 -->
    <distribution-detail-dialog ref="distributionDetail" @on-ok="queryDdata" />

    <!-- 签章  -->
    <signature-dialog ref="signature" @close-back="queryDdata" />

    <!-- 申请退换货 -->
    <apply-dialog ref="applyDialogRef" :isthh="true" />
  </div>
</template>

<script>
// 合同附件
import enclosureDialog from './enclosureDialog.vue';
// 分配查看
import distributionDetailDialog from './distributionDetailDialog.vue';
// 签章
import signatureDialog from './signatureDialog.vue';
// 申请退换货
import applyDialog from './applyDialog.vue';
import { getReOrderListSale } from '@/API';
import { displayReasonType } from '@/constant';

export default {
  components: {
    enclosureDialog,
    distributionDetailDialog,
    signatureDialog,
    applyDialog
  },

  data () {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.createBeginTime) {
            let date = new Date(this.searchForm.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      searchForm: { areaGroup: [] },
      tableLoading: false,
      tableData: [],
      Loading: false,
      returnList: ['齐套不提货撤单', '产品功能问题', '产品缺货或停产', '其他特殊原因', '市场销售原因', '税率错误', '产品发运错误'],
      statusList: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '待发布',
          value: 0
        },
        {
          label: '待分配',
          value: 1
        }
      ],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      }
    };
  },

  created () {
    this.queryDdata();
  },

  methods: {
    queryDdata () {
      this.tableLoading = true;
      let params = {
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize,
        asSale: true
      };

      getReOrderListSale(params).then((res) => {
        this.tableLoading = false;
        let { status, data } = res.data;
        if (status === '200') {
          this.tableData = data.list;
          this.page.total = data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    handerSizeChange () {
      this.page.currentPage = 1;
      this.queryDdata();
    },

    handerCurrentChange () {
      this.queryDdata();
    },

    searchData () {
      this.page.currentPage = 1;
      this.queryDdata();
    },

    resetForm () {
      this.searchForm = { areaGroup: [] };
      this.page.currentPage = 1;
      this.queryDdata();
    },

    // 项目详情
    jumpProjectDetail ({ reContractType, reContractId, reNewContractNum }) {
      let query = { rcontractType: reContractType, rcontractId: reContractId, number: reNewContractNum };
      let route = {};
      if (['换货合同', '虚拟换货合同', '价外费用合同'].includes(reContractType)) {
        route = { path: 'checkHt', query };
      } else {
        route = { path: 'checkHtChange', query };
      }
      let routeUrl = this.$router.resolve(route);
      window.open(routeUrl.href, '_blank');
    },

    // 分配
    // handleDistribution、openDistributionPage、handleSignature 已移除（未使用的死代码）

    // 合同附件
    showeContractEnclosure (row) {
      let data = JSON.parse(JSON.stringify(row));
      this.$refs.enclosure.openDialog(data);
    },

    // 分配查看（暂未接入入口）
    // showAllocationDetails (row) {
    //   let data = JSON.parse(JSON.stringify(row));
    //   this.$refs.distributionDetail.openDialog(data);
    // },

    // 申请退换货
    showApplyChange (row) {
      this.$refs.applyDialogRef.openDialog(row);
    },

    /**
     * 退换货类型展示名（D8）：落库值保持不变，仅展示层映射。
     *
     * @param {string} reasonType 后端返回的落库原因值
     * @returns {string} 展示文案
     */
    displayReasonType,

    // 显示签章按钮吗
    showSignatureBtn (row) {
      if (row.reContractStatus === 1 && ['其他特殊原因', '产品功能问题', '市场销售原因'].includes(row.reReasonType)) {
        return true;
      } else if (!['其他特殊原因', '产品功能问题', '市场销售原因'].includes(row.reReasonType)) {
        return true;
      }
      return false;
    }

  }

};
</script>

<style scoped>
  .undistributed-money .el-input {
    width: 120px !important;
  }
  .pagination-wrap {
    text-align: right;
    margin-top: 10px;
  }
  .date-separator {
    display: inline-block;
    width: 10px;
    text-align: center;
  }
</style>
